module.exports = __webpack_public_path__ + "static/media/S4N4-5.4d614b29.svg";